import React from 'react';

/**
 * Tooltip variant for use inside buttons, keeping the trigger inline so it does
 * not stretch the button's own layout.
 *
 * `align` picks the edge the bubble hangs from; see the sibling Tooltip for why
 * a centred bubble can run off small screens.
 */
const ALIGNMENT = {
  center: 'left-1/2 -translate-x-1/2',
  left: 'left-0',
  right: 'right-0',
};

export default function Tooltip({ message, children, className = '', align = 'center' }) {
  return (
    <span className={`group/tip relative inline-flex items-center justify-center gap-2 ${className}`}>
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute bottom-full z-40 mb-2 w-max max-w-[min(240px,calc(100vw-2rem))] scale-90 rounded-xl border border-white/15 bg-black/95 px-3 py-2 text-xs font-normal normal-case not-italic leading-snug tracking-normal text-white opacity-0 shadow-xl shadow-black/60 backdrop-blur transition duration-150 group-hover/tip:scale-100 group-hover/tip:opacity-100 ${
          ALIGNMENT[align] || ALIGNMENT.center
        }`}
      >
        {message}
      </span>
    </span>
  );
}
